import React from 'react'
import icn1 from '../../assets/icons/user-star.png'

const Whysec = () => {
  return (
    <section className='why-sec p-lg-5'>
                  <div class="container text-center">
                                  <div class="row justify-content-around text-center">
                                      <div class="col-md p-5">
                                              <h2 className='ws-section_heading pd-03'>Why Takshila VLSI?</h2>
                                      </div>
                                  </div>

                                  <div class="row g-3">
                                          <div class="col-lg-4 text-left">
                                              <div className='course-icon-bx bg-lt radius-1 mb-lg-4'>
                                                  <div className='icon-bx-top d-flex justify-content-between pb-4 '>
                                                      <div className='bx-title align-self-center'>Expert Trainers and Curriculum
                                                      </div>
                                                      <div className='bx-icn'><img src={icn1} alt=''/></div>
                                                  </div>
                                                  <div className='icon-bx-bottom'>
                                                      <p>We collaborate with trainers who have over 15+ years in the industry. All our
                                                      courses are professionally designed and are job-oriented to satisfy the
                                                      demands of the VLSI industry. Our courses are designed by
                                                      Professionals.
                                                      </p>
                                                  </div>
                                              </div>
                                          </div>
                                          <div class="col-lg-4 text-left">
                                          <div className='course-icon-bx bg-drk dark-bg radius-1'>
                                                  <div className='icon-bx-top d-flex justify-content-between pb-4 '>
                                                      <div className='bx-title align-self-center'>Offline/Online Courses & Affordable Fee
                                                      </div>
                                                      <div className='bx-icn'><img src={icn1} alt=''/></div>
                                                  </div>
                                                  <div className='icon-bx-bottom'>
                                                      <p>Our offline/online VLSI courses are designed to ensure that our students
                                                      gain access to training materials and classrooms at their convenience. We
                                                      offer state-of-the-art courses at very affordable prices.
                                                      </p>
                                                  </div>
                                              </div>
                                          </div>
                                          <div class="col-lg-4 text-left">
                                          <div className='course-icon-bx bg-lt radius-1'>
                                                  <div className='icon-bx-top d-flex justify-content-between pb-4 '>
                                                      <div className='bx-title align-self-center'>100% Placement Assistance
                                                      </div>
                                                      <div className='bx-icn'><img src={icn1} alt=''/></div>
                                                  </div>
                                                  <div className='icon-bx-bottom'>
                                                      <p>At Takshila VLSI technologies we provide placement support for our students
                                                      till they get placed. We collaborate with over 200+ top-level semiconductor
                                                      companies that provide us with placement opportunities for our students.
                                                      </p>
                                                  </div>
                                              </div>
                                          </div>
                                          <div class="col-lg-4 text-left">
                                          <div className='course-icon-bx bg-drk-3 dark-bg radius-1'>
                                                  <div className='icon-bx-top d-flex justify-content-between pb-4 '>
                                                      <div className='bx-title align-self-center'>Powerful EDA Tools
                                                      </div>
                                                      <div className='bx-icn'><img src={icn1} alt=''/></div>
                                                  </div>
                                                  <div className='icon-bx-bottom'>
                                                      <p>We utilize industrial standard EDA tools for hands-on training of our students.
                                                      During your period as a trainee in our VLSI institute, EDA tools are accessible
                                                      24×7 through our vpn service.
                                                      </p>
                                      </div>
                                  </div>
                              </div>
                              <div class="col-lg-4 text-left">
                              <div className='course-icon-bx bg-lt radius-1'>
                                      <div className='icon-bx-top d-flex justify-content-between pb-4 '>
                                          <div className='bx-title align-self-center'>Superior Training infrastructure and Methodology
                                          </div>
                                          <div className='bx-icn'><img src={icn1} alt=''/></div>
                                      </div>
                                      <div className='icon-bx-bottom'>
                                          <p>We use an unique training methodology for our students with 70% of the course time allocated to the labs, mini-projects, and the final projects. However, the other 30% is allocated to imparting the technologies to our student.</p>
                                      </div>
                                  </div>
                              </div>
                              <div class="col-lg-4 text-left">
                              <div className='course-icon-bx bg-drk-4 dark-bg radius-1'>
                                      <div className='icon-bx-top d-flex justify-content-between pb-4 '>
                                          <div className='bx-title align-self-center'>Value for Money
                                          </div>
                                          <div className='bx-icn'><img src={icn1} alt=''/></div>
                                      </div>
                                      <div className='icon-bx-bottom'>
                                          <p>We teach you all advanced courses at a reasonable cost. We offer you more for less. With comprehensive lessons, expert guidance, and hands-on experience, you’ll gain the skills you need to succeed without breaking the bank.

                                          </p>
                                      </div>
                                  </div>
                              </div>
                          </div>
      </div>
      </section>
  )
}

export default Whysec